export default function track(category, action, label, value, fieldsObject) {
  if ('ga' in window) {
    window.ga('send', 'event', category, action, label, value, fieldsObject);
  }
}



// WEBPACK FOOTER //
// ./src/lib/track.js